import React from 'react';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { FinishingTypeOption } from '@search/filter-enums/enums';
import { FinishingFilter } from '../../../models/Filter';

interface IFinishingFilter {
    filter: FinishingFilter;
    handleChange: (value: FinishingFilter) => void;
    classNameGroup?: string;
}

const OPTIONS: OptionType<FinishingTypeOption>[] = [
    { label: 'Без отделки', value: FinishingTypeOption.WITHOUT_FINISHING },
    { label: 'Предчистовая', value: FinishingTypeOption.PRE_FINISHING },
    { label: 'Чистовая', value: FinishingTypeOption.FINE },
    { label: 'С мебелью', value: FinishingTypeOption.WITH_FURNITURE },
];

export const FinishingFilterView: React.FC<IFinishingFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, option: FinishingTypeOption) => {
        const filters = new Set(filter.finishingType);

        filters[value ? 'add' : 'delete'](option);

        handleChange(new FinishingFilter(Array.from(filters)));
    }, [ handleChange, filter?.finishingType ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS.map(({ label, value }) => (
                <div key={value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={label}
                        value={filter?.finishingType?.includes(value)}
                        onChange={v => onChange(v, value)}
                        dataTest='finishing'
                        variant='filter'
                        block
                    >
                        {label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
